import { apiClient } from '@/services/api';
import type { ApiResponse } from '@/types/auth';
import type { WalletSummary } from '@/types/wallet';

class WalletService {
  getWallet() {
    return apiClient.get<ApiResponse<WalletSummary>>('/users/wallet');
  }

  generateVirtualAccount() {
    return apiClient.post<
      ApiResponse<{ virtualAccount: WalletSummary['virtualAccount']; created: boolean }>
    >('/users/wallet/virtual-account');
  }
}

export const walletService = new WalletService();
